import React from "react";
import { Header } from "../../header";

export default () => {
  return (
    <div className="e-settings-layout">
      <Header title="Why Option Strategies" showMenu={false}></Header>
      <div className="e-settings-content">
        <p>
          Option strategies are not compulsory for everyone. If you are earning
          very good profits with trading or technical analysis skills, then no
          need for you to look into option strategies. You can continue trading
          with your own strategy
        </p>
        <p>
          If you are new to trading or losing your capital with trading, then
          option strategies are definitely for you. Option strategies will
          protect you from wiping out your capital with few losing trades.
        </p>
        <p>
          With good risk reward ratio, you can recover your loses in multiple
          trades with a single option strategy. Check out the following video
          which explains how powerful option strategies can be
          <iframe
            width="300"
            height="315"
            src="https://www.youtube.com/embed/o5HI2PM_VQw"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </p>

        <h2>Real world example</h2>
        <p>
          Assume you are riding a bike at 75Kms per hour, without wearing a
          helmet. Suddenly you come across a pothole, you slam the breaks to cut
          speed, but it’s too late, you crash and fall. What is the probability
          of injuring your head? Quite high given the fact that you are not
          wearing a helmet.
        </p>
        <p>
          Now imagine the same situation, but instead of being carefree, you
          decide to wear a helmet. Given the crash, what is the probability of
          injuring your head? Low probability, right? Because the helmet
          protects you from an injury.
        </p>
        <p>
          The helmet acts as a hedge against a potential disaster. In the same
          way, a naked futures or options position in the market is like riding
          a bike without wearing a helmet. The risk of market-moving against
          your position, causing capital erosion is high. However, if you hedge
          your position, then the risk of losing capital reduces drastically.
        </p>
      </div>
    </div>
  );
};
